import FolderNodeViewState from '../store/schema/FolderNodeViewState';

/**
 * Utility function which creates adn returns default folderNodeViewState
 */
export default function createDefaultFolderNodeViewState(): FolderNodeViewState {
    return {
        isExpanded: false,
    } as FolderNodeViewState;
}
